module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/ai702-296862716e52db7463dd4f0897f8bf2e.jpg";